<template>
  <span
    v-if="hasStats"
    class="flex items-center flex-wrap gap-x-4 gap-y-2"
  >
    <TBadge
      v-if="isVerified"
      class="gap-2"
    >
      <TIcon
        :icon="['fas', 'circle-check']"
        fixed-width
      />
      {{ t('identityVerified') }}
    </TBadge>

    <TBadge
      v-if="isSuperhost"
      class="gap-2"
    >
      <TIcon
        :icon="['fas', 'award-simple']"
        fixed-width
      />
      {{ t('superHost') }}
    </TBadge>

    <TBadge
      v-if="hasResponseRate"
      class="gap-2"
    >
      <TIcon
        :icon="['fas', 'message-lines']"
        fixed-width
      />
      {{ t('responseRate', { responseRate }) }}
    </TBadge>
  </span>
</template>

<script setup lang="ts">
const props = defineProps<{
  isVerified?: boolean
  isSuperhost?: boolean
  responseRate?: Nullable<number>
}>()

const { t } = useI18n()

const hasResponseRate = computed(() => {
  return typeof props.responseRate === 'number'
})

const hasStats = computed(() => {
  return props.isVerified || props.isSuperhost || hasResponseRate.value
})
</script>

<i18n lang="json">
{
  "en": {
    "identityVerified": "Identity verified",
    "superHost": "Superhost",
    "responseRate": "{responseRate}% response rate"
  },
  "fr": {
    "identityVerified": "Identité vérifiée",
    "superHost": "Superhôte",
    "responseRate": "Taux de réponse de {responseRate}%"
  }
}
</i18n>
